export default __webpack_public_path__ + "static/Poster-Perroquet-fold-3-583c8d202e024f7249fbfc49f9e0db86.jpg";